import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { PrInitiatorHelperService } from 'src/app/modules/pr-initiator/services/pr-initiator-helper.service';
import { ILineItemDetail, IPurchaseRequest } from 'src/app/modules/shared/models';

@Component({
  selector: 'app-pr-details',
  templateUrl: './pr-details.component.html',
  styleUrls: ['./pr-details.component.scss']
})
export class PrDetailsComponent implements OnInit {

  public title !: string;
  public purchaseRequest !: IPurchaseRequest;
  public lineItemDetail !: ILineItemDetail;
  public onClose = new BehaviorSubject<any>({});

  public purchaseRequestForm !: FormGroup;

  constructor(
    private _helperService : PrInitiatorHelperService,
    public bsModalRef : BsModalRef) { }

  ngOnInit(): void {
    this.purchaseRequestForm = this._helperService.getPRDetailsForm();
    this.purchaseRequestForm.patchValue(this.flattenPR(this.purchaseRequest));
  }

  //TBD : temp solution
  private flattenPR(purchaseRequest : any)  : any {
    const updatedPR : any = {...purchaseRequest}
    updatedPR.address_id = purchaseRequest.address_id;
    updatedPR.delivery_address_name = purchaseRequest.delivery_address_name;
    updatedPR.delivery_address_title = purchaseRequest.delivery_address_title;
    updatedPR.delivery_address_name_1 = purchaseRequest.delivery_address_name_1;
    updatedPR.district = purchaseRequest.district;
    updatedPR.postal_code = purchaseRequest.postal_code;
    updatedPR.street_or_house_number = purchaseRequest.street_or_house_number;
    updatedPR.city = purchaseRequest.city;
    updatedPR.country = purchaseRequest.country;
    updatedPR.region = purchaseRequest.region;
    updatedPR.technical_specification = purchaseRequest.technical_specification;
    const { address, ...data } = updatedPR;
    return data;
  }

  /******** Method to be used for closing modal **********/
  public closeModal(data ?:ILineItemDetail) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public onModalClose() : void {
    this.bsModalRef.hide()
  }

}
